export const roomType = {
  SINGLE: 'single_chat',
  REALTIME: 'realtime_chat'
}
